//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

//#endregion

//-----------------------------------------------------------------
export function Logo() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();
  const _styles = {
    logo: {
      height          : '100%',
      borderRadius    : '20px',
      marginRight     : theme.spacing(1),
      padding         : '0.25rem 0.5rem 0.25rem 0',
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.logo} >
        <img alt='paradatec' src={process.env.PUBLIC_URL + '/Logo.svg'} height='90%' />
      </Box>
    );
  }

  //#endregion

  return display();
}
